module.exports = __webpack_public_path__ + "1a52a562453584654c8d331ca7954bc5.svg";